import { IconButton } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import './Buttons.scss';
import CustomTooltip from '../../../../components/card/CustomTooltip';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  ariaLabel: '',
  onClick: () => null,
  disabled: false,
};
const AddButton = (props) => {
  const { ariaLabel, onClick, disabled } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <CustomTooltip title={ariaLabel} aria-label={ariaLabel}>
      <span>
        <IconButton className='admin-action-icon-button' disabled={disabled} aria-label={ariaLabel} onClick={onClick}>
          <AddCircleIcon />
        </IconButton>
      </span>
    </CustomTooltip>
  );
};

export default AddButton;
